import { useEffect } from "react";
import { useRouter } from "next/router";
import AppLayout from "../modules/Layout/AppLayout";
import Dashboard from "../modules/Dashboard/Dashboard";
import { useAuth } from "../modules/Auth/AuthContext";

// Where each non-admin role lands: the one screen it's allowed to use. Admin
// stays on the operational Panel (Dashboard). Checked in priority order, so a
// user with several roles gets the richest destination.
function homeRouteFor({ isOperator, isScreen, isTotem }) {
  if (isOperator) return "/attention";
  if (isScreen) return "/display";
  if (isTotem) return "/checkin";
  return null;
}

export default function HomePage() {
  const router = useRouter();
  const { loading, isAdmin, isOperator, isScreen, isTotem } = useAuth();

  // The Panel (Dashboard) is admin-only; send finer roles straight to their
  // screen instead of rendering a dashboard they can't read.
  const redirect =
    !loading && !isAdmin
      ? homeRouteFor({ isOperator, isScreen, isTotem })
      : null;

  useEffect(() => {
    if (redirect) router.replace(redirect);
  }, [redirect, router]);

  if (loading || redirect) return null;

  return <Dashboard />;
}

HomePage.Layout = AppLayout;
